import { Analytics, AnalyticsEvents, Logger } from '@indigo-ag/ui-core';
import gql from 'graphql-tag';
import { get, once } from 'lodash';

import { getClient } from 'core/apollo/client';

export const trackAppLoad = once(() => {
  getClient().then(client => {
    client
      .query({
        query: gql`
          query MeQuery {
            financingCurrentUser {
              id
              email
            }
          }
        `
      })
      .then(res => {
        const userId = get(res, 'data.financingCurrentUser.email');
        Analytics.identify(userId);
        Analytics.trackEvent(AnalyticsEvents.APP_LOAD);
      })
      .catch(error => Logger.error(error));
  });
});
